const FrontEndStore = {
  namespaced: true,
  state: {
    mainContent: ''
  }
}

export default FrontEndStore
